import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import type { HouseAd } from '../ads/houseAds';

interface Props {
  ad: HouseAd;
  onClose: () => void;
  onRemoveAds: () => void;
}

/** Full-screen KCL house ad, cross-faded over the slideshow. */
export function HouseAdSlide({ ad, onClose, onRemoveAds }: Props) {
  return (
    <motion.div
      className="absolute inset-0 z-30 flex items-end"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1.6, ease: 'easeInOut' }}
      style={{ background: ad.image ? `center / cover no-repeat url("${ad.image}")` : ad.scene }}
      role="complementary"
      aria-label="Advertisement from Kirkpatrick Consult Limited"
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <div className="relative max-w-3xl p-10 text-white md:p-16">
        <div className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] opacity-70">Ad · Kirkpatrick Consult Limited</div>
        <h2 className="text-4xl font-semibold leading-tight md:text-6xl">{ad.headline}</h2>
        <p className="mt-4 text-lg opacity-90 md:text-2xl">{ad.body}</p>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a
            href={ad.url}
            target="_blank"
            rel="noopener"
            className="rounded-full bg-white px-6 py-3 font-medium text-black transition hover:bg-white/90"
          >
            {ad.cta} →
          </a>
          <button onClick={onRemoveAds} className="rounded-full border border-white/40 px-5 py-3 text-sm hover:bg-white/10">
            Remove ads forever – £10
          </button>
        </div>
      </div>
      <button
        onClick={onClose}
        className="absolute right-6 top-6 rounded-full bg-black/40 p-2 text-white hover:bg-black/60"
        aria-label="Close advertisement"
      >
        <X className="h-5 w-5" aria-hidden />
      </button>
    </motion.div>
  );
}
